import * as React from 'react';

import {CategoryResults} from './CategoryResults';
import {ItemResults} from './ItemResults';
import {SearchResult} from '../search.types';
import {SerializedURLBuilder, URLBuilder} from '../../../server/tools/url-builder/url-builder.class';
import {User} from '../../users/user.class';

interface ResultPaneProps {
    debugWebcat: boolean;
    resultList?: SearchResult;
    serializedURLBuilder: SerializedURLBuilder;
    stepIdPath: string;
    user: User;
}

export const ResultPane = ({debugWebcat, resultList, serializedURLBuilder, stepIdPath, user}: ResultPaneProps) => {
    const buildURL = URLBuilder.fromSerialized(serializedURLBuilder);
    if (resultList.totalItems === 0) {
        return null;
    }
    if (
        resultList.layout === 'items' ||
        resultList.layout === 'search' ||
        resultList.layout === 'campaign' ||
        resultList.layout === 'collection' ||
        resultList.layout === 'wiper-blades'
    ) {
        return (
            <ItemResults
                buildURL={buildURL}
                debugWebcat={debugWebcat}
                resultList={resultList}
                stepIdPath={stepIdPath}
                user={user}
            />
        );
    }
    return (
        <CategoryResults
            buildURL={buildURL}
            debugWebcat={debugWebcat}
            resultList={resultList}
            stepIdPath={stepIdPath}
            user={user}
        />
    );
};
